<template lang="pug">
TicketView(
  :ticket="props.ticket",
  :use-auth="useSFWAuth",
  :ticket-template-query="{ type: normalTicketTypeQuery }",
  :preview="props.preview",
  ticket-history-view-name="sfwTicketHistory",
  hide-sops
)
</template>

<script setup lang="ts">
import type { TwinResponse } from "@shared/services/twinManagement";
import TicketView from "@shared/components/tickets/TicketView.vue";
import { useSFWAuth } from "../hooks/sfwAuth";
import { normalTicketTypeQuery } from "../constants";

const props = defineProps<{
  ticket: TwinResponse;
  preview?: boolean;
}>();
</script>
